document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".skip-btn").forEach((button) => {
    button.addEventListener("click", function () {
      try {
        const currentSection = this.closest(".shopify-section");
        if (!currentSection) {
          console.warn(
            "Could not find parent .shopify-section of the skip button."
          );
          return;
        }

        let nextSection = currentSection.nextElementSibling;

        while (nextSection && !nextSection.matches(".shopify-section")) {
          nextSection = nextSection.nextElementSibling;
        }

        if (nextSection) {
          // const nextHeading = nextSection.querySelector(".cs_heading_fs");

          // if (nextHeading) {
          //   nextHeading.scrollIntoView({ behavior: "smooth", block: "center" });
          //   nextHeading.focus({ preventScroll: true });
          // } else {
          nextSection.scrollIntoView({ behavior: "smooth", block: "center" });

          nextSection.setAttribute("tabindex", "-1");
          nextSection.focus({ preventScroll: true });

          nextSection.addEventListener(
            "blur",
            () => {
              nextSection.removeAttribute("tabindex");
            },
            { once: true }
          );

          console.warn(
            "Next section does not have a '.cs_heading_fs' to focus. Focusing section instead."
          );
          // }
        } else {
          console.warn("No next shopify-section found.");
        }
      } catch (error) {
        console.error("Error during skip-to-next-section logic:", error);
      }
    });
  });
});
